<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.data.disposition)">
        <span>{{ checkStatus(params.data.disposition) }}</span>
    </vs-chip>
</template>

<script>
export default {
    name: "CellRendererStatus",
    computed: {
        chipColor() {
            return value => {
                if (value == 'MORE') {
                    return "success";
                } else if (value == 'MISSCALL') {
                    return 'warning'
                } else if (value == 'ANSWER') {
                    return 'success'
                } else if (value == 'BUSY') {
                    return 'danger'
                } else if (value == 'NOANSWER') {
                    return 'warning'
                } else if (value == 'CANCEL') {
                    return 'danger'
                } else if (value == 'SOMEONEANSWERED') {
                    return 'warning'
                } else if (value == 'LOGOUT') {
                    return 'warning'
                } else if (value == 'INCALL') {
                    return 'warning'
                } else if (value == 'CONGESTION' || value == 'CHANUNAVAIL' || value == 'DONTCALL' || value == 'TORTURE' || value == 'INVALIDARGS' || value == 'ORMAL_CLEARING') {
                    return 'danger'
                }
            }
        },
        checkStatus() {
            return value => {
                if (value == 'MORE') {
                    return "Nhiều trạng thái khác của cuộc gọi";
                } else if (value == 'MISSCALL') {
                    return 'Cuộc gọi nhỡ'
                } else if (value == 'ANSWER') {
                    return 'Nghe máy'
                } else if (value == 'BUSY') {
                    return 'Người nhận bận'
                } else if (value == 'NOANSWER') {
                    return 'Người nhận không trả lời'
                } else if (value == 'CANCEL') {
                    return 'Người gọi hủy cuộc gọi'
                } else if (value == 'SOMEONEANSWERED') {
                    return 'Đã có người khác nghe máy'
                } else if (value == 'LOGOUT') {
                    return 'Đang trong trạng thái Logout'
                } else if (value == 'INCALL') {
                    return 'Đang trong cuộc gọi khác'
                } else if (value == 'CONGESTION' || value == 'CHANUNAVAIL' || value == 'DONTCALL' || value == 'TORTURE' || value == 'INVALIDARGS' || value == 'ORMAL_CLEARING') {
                    return 'Lỗi cuộc gọi'
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.ag-grid-cell-chip {
    &.vs-chip-success {
        background: rgba(var(--vs-success), .2);
        color: rgba(var(--vs-success), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-danger {
        background: rgba(var(--vs-danger), .2);
        color: rgba(var(--vs-danger), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-warning {
        background: rgba(var(--vs-warning), .2);
        color: rgba(var(--vs-warning), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-pending {
        background: rgb(143, 143, 143, .2) !important;
        color: rgb(143, 143, 143) !important;
        font-weight: 500;
    }

    &.vs-chip-complete {
        background: rgba(157, 101, 201, .2) !important;
        color: rgb(157, 101, 201) !important;
        font-weight: 500;
    }
}
</style>
